// extracted by css-extract-rspack-plugin
export default {"previewOverlay":"_9f282a9"};